module.exports = __webpack_public_path__ + "assets/8435223ad29c23e22c4ba4272f8a8458.png";